var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackageCancel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.11803 0H7V4H1.5L3.22361 0.552786C3.393 0.214002 3.73926 0 4.11803 0Z",
    fill: "#C43232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4H8V0H10.882C11.2607 0 11.607 0.214002 11.7764 0.552786L13.5 4Z",
    fill: "#C43232"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 5H1.5V13C1.5 13.5523 1.94772 14 2.5 14H12.5C13.0523 14 13.5 13.5523 13.5 13V5ZM9.64655 11.8535L7.5001 9.70709L5.35365 11.8535L4.64655 11.1464L6.79299 8.99998L4.64655 6.85353L5.35365 6.14643L7.5001 8.29287L9.64655 6.14643L10.3537 6.85353L8.20721 8.99998L10.3537 11.1464L9.64655 11.8535Z",
    fill: "#C43232"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageCancel);
export default __webpack_public_path__ + "static/media/package_cancel.ac0e6900.svg";
export { ForwardRef as ReactComponent };